'use strict';

var deliveryUtils = require('../components/deliveryModal/deliveryUtils');
var base = require('./base');

/**
 * Recalculates the disabled state of each multiple-qty button based on the current
 * quantity in the cart, available stock, and max order quantity.
 *
 * @param {jQuery} $block - The `.multiple-qty-block` container element.
 * @param {number} qtyInCart - The current quantity of this product already in the cart.
 */
function updateButtonStates($block, qtyInCart) {
    var availableQty = parseInt($block.data('available-qty'), 10);
    var maxOrderQty = parseInt($block.data('max-order-qty'), 10);
    $block.data('qty-in-cart', qtyInCart);

    $block.find('.btn-multiple-qty').each(function checkButton() {
        var btnQty = parseInt($(this).data('qty'), 10);
        var wouldExceedStock = (qtyInCart + btnQty) > availableQty;
        var wouldExceedMax = (qtyInCart + btnQty) > maxOrderQty;
        $(this).prop('disabled', wouldExceedStock || wouldExceedMax);
    });
}

module.exports = {
    /**
     * Initializes the multiple-qty buttons feature on the PDP.
     * - Handles click on `.btn-multiple-qty`: validates delivery method, then calls
     *   base.submitAddToCart directly with the desired quantity.
     * - Listens to `product:afterAddToCart` to recalculate which buttons should be disabled
     *   based on the updated cart state.
     */
    init: function () {
        $(document).on('click', '.btn-multiple-qty', function handleMultipleQtyClick() {
            var $btn = $(this);
            var pid = $btn.data('pid');

            if ($btn.prop('disabled')) return;

            if (!deliveryUtils.isDeliveryAddressSet()) {
                $(document).trigger('openDeliveryModalRequest', {
                    redirectUrl: base.getPDPURL(pid)
                });
                return;
            }

            var quantity = parseInt($btn.data('qty'), 10);
            if (!quantity || quantity <= 0) return;

            base.submitAddToCart(pid, quantity);
        });

        $('body').on('product:afterAddToCart', function handleAfterAddToCart(e, data) {
            var $block = $('.multiple-qty-block');
            if (!$block.length) return;

            var pid = String($block.data('pid'));
            var currentQtyInCart = parseInt($block.data('qty-in-cart'), 10) || 0;

            var items = (data.cart && data.cart.items) || data.items;
            if (items) {
                var total = 0;
                items.forEach(function sumItemQty(item) {
                    if (String(item.id) === pid) {
                        total += item.quantity;
                    }
                });
                currentQtyInCart = total;
            }

            updateButtonStates($block, currentQtyInCart);
        });
    }
};
